import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { AuthService as Auth0SDKService } from "@auth0/auth0-angular";
import { Observable } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { Auth0Service } from "../../auth/auth0.service";

@Injectable()
export class Auth0Interceptor implements HttpInterceptor {

  private readonly auth0 = inject(Auth0SDKService);
  private readonly auth0Service = inject(Auth0Service);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only intercept requests to your API
    if (!request.url.startsWith(environment.baseApiUrl)) {
      return next.handle(request);
    }

    if (!this.auth0Service.isAuth0Login) {
      // Normal login - don't attach token
      return next.handle(request);
    }

    // Auth0 login - attach token only if authenticated
    return this.auth0.isAuthenticated$.pipe(
      take(1),
      switchMap(isAuthenticated => {
        if (!isAuthenticated) {
          // Auth0 user but not authenticated yet - skip token
          return next.handle(request);
        }

        // Authenticated via Auth0 - attach token
        return this.auth0.getAccessTokenSilently().pipe(
          take(1),
          switchMap(token => {
            const authRequest = request.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`,
              },
            });
            return next.handle(authRequest);
          })
        );
      })
    );
  }
}
